//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[["context"],"SetContext",{},1,0],[[],"GetContext",{R_:{context:''}},0,0],[["num_contexts"],"GetAllContexts",{R_:{contexts:""}},0,0],[["id_type"],"SetIdType",{},1,0],[[],"GetIdType",{R_:{id_type:''}},0,0],[["context","num_id_types"],"GetAllIdTypes",{R_:{id_types:""}},1,0],[["alternate_item_id"],"SetAlternateItemId",{},1,0],[["alternate_item_id","alternate_rev_id"],"AssignAlternateId",{},0,0],[[],"GetAlternateItemId",{R_:{alternate_item_id:''}},0,0],[["alternate_rev_id"],"SetAlternateRevId",{},1,0],[[],"AssignAlternateRevId",{R_:{alternate_rev_id:''}},0,0],[[],"GetAlternateRevId",{R_:{alternate_rev_id:''}},0,0],[["alternate_name"],"SetAlternateName",{},1,0],[[],"GetAlternateName",{R_:{alternate_name:''}},0,0],[["alternate_description"],"SetAlternateDescription",{},1,0],[[],"GetAlternateDescription",{R_:{alternate_description:''}},0,0],[["alternate_id_as_default_indentifier"],"SetAlternateIdAsDefaultIndentifier",{},1,0],[[],"GetAlternateIdAsDefaultIndentifier",{R_:{alternate_id_as_default_indentifier:''}},0,0],[["context","id_type","alternate_item_id","alternate_rev_id","alternate_name","alternate_description","alternate_id_as_default_indentifier"],"SetAlternateIdInformation",{},7,0],[[],"CreateAlternateIdInformation",{},0,0],[["context","id_type"],"AssignAlternateIds",{R_:{alt_info:''}},2,0],[[],"AssignAlternateRevision",{R_:{revInfo:''}},0,0]],[]];
SPLM.PDM.AlternateIdManager = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.AlternateIdManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PDM.AlternateIdManager.AlternateIdsData = class{
    constructor(alternate_item_id,alternate_rev_id,alternate_name,alternate_description,modifiable){
        this.alternate_item_id=alternate_item_id;this.alternate_rev_id=alternate_rev_id;this.alternate_name=alternate_name;this.alternate_description=alternate_description;this.modifiable=modifiable;}
    get AlternateItemId(){return this.alternate_item_id}
    set AlternateItemId(val){this.alternate_item_id = val}
    get AlternateRevId(){return this.alternate_rev_id}
    set AlternateRevId(val){this.alternate_rev_id = val}
    get AlternateName(){return this.alternate_name}
    set AlternateName(val){this.alternate_name = val}
    get AlternateDescription(){return this.alternate_description}
    set AlternateDescription(val){this.alternate_description = val}
    get Modifiable(){return this.modifiable}
    set Modifiable(val){this.modifiable = val}
};

SPLM.PDM.AlternateIdManager.AssignAlternateRevData = class{
    constructor(alternate_rev_id,modifiable){
        this.alternate_rev_id=alternate_rev_id;this.modifiable=modifiable;}
    get AlternateRevId(){return this.alternate_rev_id}
    set AlternateRevId(val){this.alternate_rev_id = val}
    get Modifiable(){return this.modifiable}
    set Modifiable(val){this.modifiable = val}
};

export default SPLM;